import { Component } from '@angular/core';
import { NavController, Events } from 'ionic-angular';

// Providers
import { ProvidersService } from '../../providers/providers/providers-service';
import { InstructorsService } from '../../providers/instructors/instructors-service';

// Helpers
import { HelperCsvService } from '../../providers/helpers/helper-csv-service';

// Pages
import { InstructorAddEditPage } from '../instructors/instructor-add-edit';

@Component({
  selector: 'page-report-instructors-location',
  templateUrl: 'report.instructors-location.html'
})
export class ReportInstructorsLocationPage {
  headerData: any;
  instructors:any = [];
  gotRecords:boolean = false;
  searchResults:boolean = false;
  searchTerm:string = '';

  constructor(
    public navCtrl: NavController,
    public events: Events,
    public providersService: ProvidersService,
    public instructorsService: InstructorsService,
    public helperCsvService: HelperCsvService
  ) {
    this.headerData = { title: 'Instructors by Location' };
  }

  createReport( ev )
  {
    let search_term = ev.target.value;
    this.searchTerm = search_term;

    if ( search_term && search_term.length > 3 )
    {
      // Clear this.instructors array to prep for search results.
      this.instructors.length = 0;

      this.instructorsService.searchInstructors(search_term).subscribe(data => {
        this.searchResults = true;
        this.instructors = data;

        if ( this.instructors.length === 0 )
        {
          this.searchResults = false;
        } else {
          this.gotRecords = true;
        }
      });
    } else {
      this.clearSearch();
    }
  }

  clearSearch()
  {
    // Clear instructors array.
    this.instructors.length = 0;
    this.searchResults = false;
    this.gotRecords = false;
  }

  showInstructorAddEditPage( instructor = null )
  {
    this.navCtrl.push( InstructorAddEditPage, {
      instructor: instructor
    });
  }

  createReportCSV()
  {
    this.helperCsvService.exportInstructorList( this.instructors, 'Instructors for ' + this.searchTerm + ' List.csv' );
  }
}


// WEBPACK FOOTER //
// ./src/pages/reports/report.instructors-location.ts